export const FIRST_LEFT_COL_WIDTH = 440;
export const IDS_COL_WIDTH = 120;
export const HOURS_WIDTH = 50;
export const CHEVRON_COL_WIDTH = 30;
export const BUDGET_LEFT_COL_WIDTH = 130;
export const TOTAL_BUDGET_LEFT_COL_WIDTH = 130;
export const DESCRIPTION_COL_WIDTH = 470;
